
(function( ){

//------------------------------------------------------------------------------------------------------------------------------

	EasyModal = function( )
	{
		var _this = this, i;



		var CONTENT = "content" ;
		var OPEN = "open" ;
		var CLOSE = "close" ;


		var html = document.documentElement;
		var body = document.body;
		var bodyStyle = document.createElement("style");
		bodyStyle.innerHTML = "body{overflow:hidden;}";


		var _onOpenClose = function( evt )
		{
			var target = evt.currentTarget ;
			var content = EasyModal.instance[target.easeModalID].content ;

			switch( target.buttonType )
			{
				case OPEN :
					content.className = content.defaultClassName + " " + target.appnedClassName ;
					body.appendChild(bodyStyle) ;
					break ;

				case CLOSE :
					content.className = content.defaultClassName + " " + target.appnedClassName ;
					if( bodyStyle.parentNode ){
						bodyStyle.parentNode.removeChild(bodyStyle);
					}
					break ;
			}
		}


		var target = document.getElementsByClassName( "js-easyModal" );

		for(i = 0; i < target.length; i++){
			var temp = target[i] ;
			var data = temp.getAttribute( "data-easyModal" ).split(",");

			if(!EasyModal.instance[data[0]]) {
				EasyModal.instance[data[0]] = {
					content: null,
					open: [],
					close: []
				}
			}

			temp.easeModalID = data[0] ;

			switch(data[1]){
				case CONTENT :
					EasyModal.instance[data[0]].content = temp ;
					temp.defaultClassName = temp.className ;
					break ;

				case OPEN :
					EasyModal.instance[data[0]].open.push( temp );
					temp.appnedClassName = data[2] || "show" ;
					temp.buttonType = OPEN ;
					temp.addEventListener( "click" , _onOpenClose ) ;
					break ;

				case CLOSE :
					EasyModal.instance[data[0]].close.push( temp );
					temp.appnedClassName = data[2] || "hide" ;
					temp.buttonType = CLOSE ;
					temp.addEventListener( "click" , _onOpenClose ) ;
					break ;
			}
		}
	}
	EasyModal.instance = {} ;

//------------------------------------------------------------------------------------------------------------------------------

	// DOMの準備が完了したら、呼ぶ
	document.readyState === "complete"
		? setTimeout( function(){ new EasyModal() ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new EasyModal() ; } ) ;

} )( ) ;
